export const UPDATE_FIELD = 'UPDATE_FIELD';
export const SET_PROSPECT_FIELD = 'SET_PROSPECT_FIELD';
export const SET_PLANCODE = 'SET_PLANCODE';
export const SET_BILLING_METHOD = 'SET_BILLING_METHOD';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_LOADING = 'SET_LOADING';
export const ON_CAPTCHA_TOKEN_VERIFY = 'ON_CAPTCHA_TOKEN_VERIFY';
export const ON_CAPTCHA_ERROR = 'ON_CAPTCHA_ERROR';
export const ON_CAPTCHA_EXPIRED = 'ON_CAPTCHA_EXPIRED';
export const ON_RECURLY_TOKEN_ERROR = 'ON_RECURLY_TOKEN_ERROR';
export const ON_ALT_PAYMENT_CANCEL = 'ON_ALT_PAYMENT_CANCEL';
export const ON_SUBMIT_ERROR = 'ON_SUBMIT_ERROR';
export const ON_ACCEPTED_TERMS = 'ON_ACCEPTED_TERMS';

const actions = {
  UPDATE_FIELD,
  SET_PROSPECT_FIELD,
  SET_PLANCODE,
  SET_BILLING_METHOD,
  SET_TOTAL,
  SET_LOADING,
  ON_CAPTCHA_TOKEN_VERIFY,
  ON_CAPTCHA_ERROR,
  ON_CAPTCHA_EXPIRED,
  ON_RECURLY_TOKEN_ERROR,
  ON_ALT_PAYMENT_CANCEL,
  ON_SUBMIT_ERROR,
  ON_ACCEPTED_TERMS,
};

export default actions;
